var _path, _path2, _circle, _rect, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrake(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80915 5.77599C2.39758 5.49728 1.83477 5.6035 1.58767 6.03479C0.483323 7.9624 -0.0672659 10.1646 0.00655794 12.3967C0.0803818 14.6288 0.775278 16.7897 2.00458 18.6402C2.27963 19.0542 2.84824 19.123 3.24049 18.8177V18.8177C3.63274 18.5124 3.69948 17.9488 3.42993 17.5312C2.43112 15.9837 1.86683 14.1892 1.80557 12.3372C1.74432 10.4851 2.18881 8.65731 3.08318 7.04716C3.32455 6.61264 3.22071 6.0547 2.80915 5.77599V5.77599Z",
    fill: "#2F3D57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1909 5.77599C21.6024 5.49728 22.1652 5.6035 22.4123 6.03479C23.5167 7.9624 24.0673 10.1646 23.9934 12.3967C23.9196 14.6288 23.2247 16.7897 21.9954 18.6402C21.7204 19.0542 21.1518 19.123 20.7595 18.8177V18.8177C20.3673 18.5124 20.3005 17.9488 20.5701 17.5312C21.5689 15.9837 22.1332 14.1892 22.1944 12.3372C22.2557 10.4851 21.8112 8.65731 20.9168 7.04716C20.6755 6.61264 20.7793 6.0547 21.1909 5.77599V5.77599Z",
    fill: "#2F3D57"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "#2F3D57"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5,
    width: 2,
    height: 11,
    rx: 1,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrake);
export default __webpack_public_path__ + "static/media/brake.f86a080b434f482f229fdb8ad782319c.svg";
export { ForwardRef as ReactComponent };